module.exports = __webpack_public_path__ + "static/active-5134983cc88411c927fda1f5ae989e49.mp4";